import type { CommonUserStats } from '@@partner:types:graphql'

import React from 'react'

import { Link } from 'react-router-dom'
import { Panel, Button, Divider, ButtonGroup } from 'rsuite'
import LegacyAvatarIcon from '@rsuite/icons/legacy/Avatar'
import LegacyCheckCircleIcon from '@rsuite/icons/legacy/CheckCircle'
import LegacyCloseCircleIcon from '@rsuite/icons/legacy/CloseCircle'
import AppLoader from '@components/common/AppLoader'

export interface UsersStatisticPanelProps {
  header?: string
  loading?: boolean
  stats?: CommonUserStats
  manageLink?: string
  createLink?: string
}

const DEFAULT_STATS_OBJECT: CommonUserStats = {
  active: 0,
  disabled: 0,
  total: 0
}

const UsersStatisticPanel: React.FC<UsersStatisticPanelProps> = ({
  header = '',
  stats = DEFAULT_STATS_OBJECT,
  loading = false,
  manageLink,
  createLink
}) => {
  return (
    <Panel shaded header={header}>
      <div>
        <LegacyAvatarIcon />
        &nbsp;
        <strong>Всего</strong> {loading ? <AppLoader.Inline /> : stats.total}
      </div>
      <div>
        <LegacyCheckCircleIcon />
        &nbsp;
        <strong>Активные</strong>{' '}
        {loading ? <AppLoader.Inline /> : stats.active}
      </div>
      <div>
        <LegacyCloseCircleIcon />
        &nbsp;
        <strong>Отключённые</strong>{' '}
        {loading ? <AppLoader.Inline /> : stats.disabled}
      </div>
      <Divider />
      <div className="mt-4 text-right">
        <ButtonGroup>
          {createLink ? (
            <Button
              as={Link}
              to={createLink}
              appearance="primary"
              color="green"
              size="xs"
            >
              Добавить
            </Button>
          ) : null}

          {manageLink ? (
            <Button
              as={Link}
              to={manageLink}
              // appearance="primary"
              color="cyan"
              size="xs"
            >
              Управление
            </Button>
          ) : null}
        </ButtonGroup>
      </div>
    </Panel>
  )
}

export default UsersStatisticPanel
